import { RangerService } from '../model/ranger.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { Ranger } from 'assets-model';
import { Observable } from 'rxjs';


export class RangerDataSource extends CrudDataSource<Ranger> {

  constructor(private service: RangerService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<Ranger>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


